var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"rule-content"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._v(" "),(_vm.referer != 'Menu')?_c('div',{staticClass:"btn btn-blue btn-block",on:{"click":_vm._startAn}},[_vm._v("Start")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6491c306","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rule.vue
// module id = null
// module chunks = 